import React, { createContext, useState, useEffect, useCallback } from "react";
import { logoutClient, refreshTokens } from "../api/auth";
import { setLogoutHandler } from "./authEventBus";

// Create the AuthContext
export const AuthContext = createContext();

// AuthProvider Component
export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    // Initialize from sessionStorage
    return sessionStorage.getItem("isLoggedIn") === "true";
  });

  // Sync isLoggedIn with sessionStorage
  useEffect(() => {
    sessionStorage.setItem("isLoggedIn", isLoggedIn);
  }, [isLoggedIn]);

  // Token refresh logic: Refresh every 5 minutes
  useEffect(() => {
    if (isLoggedIn) {
      const interval = setInterval(() => {
        refreshTokens()
          .then(() => console.log("Tokens refreshed successfully."))
          .catch((error) => {
            console.error("Error refreshing tokens:", error);
            // Optionally log the user out if refreshing fails
            if (error.response?.status === 401) {
              setIsLoggedIn(false);
            }
          });
      }, 1 * 60 * 1000); // Refresh every 5 minutes

      return () => clearInterval(interval); // Cleanup interval on unmount
    }
  }, [isLoggedIn]);


  const login = useCallback(() => {
    setIsLoggedIn(true);
  }, []);

  const logout = useCallback(async () => {
    try {
      await logoutClient();
      setIsLoggedIn(false);
    } catch (error) {
      console.log("logout error");
    }
  }, []);

  useEffect(() => {
    setLogoutHandler(logout); // inject logout globally
  }, [logout]);

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
